module.exports = __webpack_public_path__ + "img/full7-min.4bd8ed91.png";